var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { a11yProps } from '../../../modules/Shops/helpers.shops';
import { createTabs } from './helpers.tabs';
import { theme } from './TabsTheme';
var EMPTY_TAB_OPACITY = 0.6;
var DIRTY_TAB_OPACITY = 1;
var ShopTabs = function (_a) {
    var value = _a.value, onChange = _a.onChange, shops = _a.shops;
    var t = useTranslation('settings').t;
    var allTabs = createTabs(shops);
    return (_jsx(Tabs, { value: value, onChange: onChange, "aria-label": "shop tabs", variant: "scrollable", scrollButtons: "auto", children: allTabs.map(function (tab) {
            var label = tab.shop ? tab.label : t(tab.label);
            return (_jsx(Tab, __assign({ label: label }, a11yProps(tab.index), { sx: __assign(__assign({}, theme.tab), { opacity: tab.isEmpty ? EMPTY_TAB_OPACITY : DIRTY_TAB_OPACITY }) }), tab.index));
        }) }));
};
export default ShopTabs;
